const TRANSLATION_NAMESPACE = "error:menu."

export const FETCH_MAIN_MENU_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}fetch-main-menu-failed`
export const SELECT_MAIN_MENU_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}select-main-menu-failed`
export const SET_SIDEBAR_STATE_FAILED_MESSAGE = `${TRANSLATION_NAMESPACE}`
